import React from 'react';
import cn from 'classnames';

import { ensureAbsoluteUrl } from './utils';
import styles from './ExternalLink.module.scss';

export type ExternalLinkProps = {
  href: string;
  linkText: string;
  text?: string;
  openInNewTab?: boolean;
  className?: string;
};

const ExternalLink: React.FC<ExternalLinkProps> = ({
  href,
  linkText,
  text,
  openInNewTab = true,
  className
}) => {
  const absoluteHref = ensureAbsoluteUrl(href);
  const target = openInNewTab ? '_blank' : '_self';
  const rel = openInNewTab ? 'noopener noreferrer' : undefined;

  const handleClick = React.useCallback(
    (e: React.MouseEvent<HTMLAnchorElement>) => {
      e.stopPropagation();
    },
    []
  );

  // Если передан текст, заменяем вхождение linkText на ссылку
  if (text) {
    const linkIndex = text.indexOf(linkText);

    // Если текст не содержит linkText, просто возвращаем текст
    if (linkIndex === -1) {
      return <span className={className}>{text}</span>;
    }

    const before = text.substring(0, linkIndex);
    const after = text.substring(linkIndex + linkText.length);

    return (
      <span className={className}>
        {before}
        <a
          href={absoluteHref}
          target={target}
          rel={rel}
          onClick={handleClick}
          className={styles['external-link']}
        >
          {linkText}
        </a>
        {after}
      </span>
    );
  }

  // Если текст не передан, просто возвращаем ссылку
  return (
    <a
      href={absoluteHref}
      target={target}
      rel={rel}
      onClick={handleClick}
      className={cn(styles['external-link'], className)}
    >
      {linkText}
    </a>
  );
};

export default React.memo(ExternalLink);
